
import { useState, useEffect, useRef } from 'react';
import { DataScroller } from 'primereact/datascroller';
import { Image } from 'primereact/image';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { getAllCustomerInfo } from '../../service/allCustomerInfo.service';
import React from 'react';
import LoadingSpinner from '../loading-spinner/loading-spinner';
import { goTo } from '../../utilities/common.utilities';
import { Toast } from 'primereact/toast';
import ImageWithErrorHandling from '../Shared/ImageWithErrorHandling/imageWithErrorHandling.component';
import { useConnectivity } from '../../context/connectivityContext';
// import { Document } from 'react-pdf';
import "./flyers.css"

interface Magazines {
    id: string;
    file: string;
    name: string;
    validFrom: string;
    validTo: string;
    thumbnail: string;
}

export default function FlyersComponent() {
    const [magazines, setMagazines] = useState<Magazines[]>([]);
    const toastFlyers = useRef<Toast>(null);
    const location = useLocation();

    // Se non sono presenti dati in location.state, reindirizzo in home al posto
    // di far andare in errore il componente
    if(!location.state) {
        goTo('/home');
    }

    const { cardData } = location.state;
    const [isLoading, setLoader] = useState<boolean>(true);

    // Variabile utilizzata per sapere se ci sono errori nella ricezione dei volantini come l' assenza di connessione.
    // Utilizzata per distinguere sul template, se la mancanza di volantini è dovuta ad errore oppure effettivamente non c'è ne sono.
    const [errorGetFlyers, setErrorGetFlyers] = useState<boolean>(false);
    const { isOnline } = useConnectivity();

    const isPdf = (file: string) => {
        let type = file.split('.')[1];
        if(type === 'pdf'){
            return true;
        } else {
            return false;
        }
    }
    

    const getMagazines = () => {
        
            getAllCustomerInfo(cardData.groupCode, cardData.storeCode, cardData.selectedCard).then(allCustomerInfo => {
                let result: Magazines[] = [];
                setErrorGetFlyers(false); 

                    if(!allCustomerInfo) {
                        setErrorGetFlyers(true);
                    }
                    else if(allCustomerInfo?.magazines?.items?.length > 0){
                       result = allCustomerInfo.magazines.items;
                    } else { 
                       result = [];
                    }

                    if(result.length > 0){
                        setMagazines(result);
                      } else {
                        setMagazines([]);
                    }
    
                    setLoader(false);
            });
    }

    const downloadMagazine = (id: string, file: string) => {
        if(navigator.onLine) {
            window.open(process.env.REACT_APP_STORAGE_URL+`/groups/`+cardData.groupCode+`/magazines/`+id+`/`+file)
        }
        else {
            let message: string = 'Per visualizzare un volantino, bisogna essere connessi ad internet.';
            toastFlyers.current?.show({ severity: 'error', summary: 'Attenzione', detail: message }); 
        }
    }

    useEffect(() => {
     getMagazines();
    }, [isOnline]);  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore

    const itemTemplate = (data: Magazines) => {
        return (
            <div className="col-12 bg-white mt-2 p-0 mb-4 custom-card flyers-style-component">
                <div className="flex flex-column">
                    {
                        !isPdf(data.file) ? 
                        <ImageWithErrorHandling src={process.env.REACT_APP_STORAGE_URL+`/groups/`+cardData.groupCode+`/magazines/`+data.id+`/`+data.file} style={{ borderRadius: "8px 8px 0 0" , borderBottom: '1px solid #edecec'}} alt={data.name}/>
                        : 
                        <ImageWithErrorHandling src={process.env.REACT_APP_STORAGE_URL+`/groups/`+cardData.groupCode+`/magazines/`+data.id+`/`+data.thumbnail} style={{ borderRadius: "8px 8px 0 0" , borderBottom: '1px solid #edecec'}} alt={data.name}/>
                    }

                    <div className="p-2 pt-0">
                        <div className="flex overflow-hidden">
                            <div className="flex-grow-1 flex align-items-start justify-content-start">
                                <h2 className="mt-2 mb-0">{data.name}</h2>
                            </div>
                        </div>
                        
                            <div className="flex-grow-1 flex align-items-start justify-content-start p-1 mt-2">
                                <div style={{ color: "green" }}>
                                    <div className="flex flex-row flex-wrap">
                                    <div className="flex align-items-end justify-content-start ">
                                        <div
                                        className="text-left font-bold from-to-style-flyers"
                                        style={{ fontSize: "10px" }}
                                        >
                                        VALIDO DAL
                                        </div>
                                        <div className=" ml-2 text-left font-bold">
                                        {moment(data.validFrom).format("DD/MM/YYYY")}
                                        </div>
                                        <div
                                        style={{ fontSize: "10px" }}
                                        className="ml-2 text-right font-bold from-to-style-flyers"
                                        >
                                        AL
                                        </div>
                                        <div className="ml-2 text-left font-bold">
                                        {moment(data.validTo).format("DD/MM/YYYY")}
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div> 
                            {
                                isPdf(data.file) ?
                                <div className="flex overflow-hidden">
                                    <div className="flex-grow-1 flex align-items-center justify-content-start">
                                        <div
                                            className="flex-none flex align-items-center justify-content-end p-1"
                                            style={{cursor:'pointer'}}
                                            onClick={() => downloadMagazine(data.id, data.file)}>
                                            <div
                                                className="flex p-1"
                                                style={{
                                                    fontSize: "12px",
                                                    border: "1px solid #93c021",
                                                    borderRadius: "8px",
                                                }}>
                                                <div className="font-bold px-2">Apri il Volantino</div>
                                                <i
                                                    className="pi pi-file-pdf ml-1 mr-2"
                                                    style={{ fontSize: "1rem" }}
                                                ></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : <div></div>
                            }
                                
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <Toast ref={toastFlyers} position="top-center" />
            <div className="flex justify-content-center">
                <h2 className="mb-0 mt-2">Volantini</h2>
            </div>
            <DataScroller 
            value={magazines} 
            itemTemplate={itemTemplate} 
            rows={100} 
            buffer={0.4} 
            header="" 
            emptyMessage={
                <div className="text-center text-lg mt-5">

                  {
                    errorGetFlyers
                    ?
                    <div className="flex flex-column">

                    {
                        isOnline
                        ?
                        <></>
                        :
                        <div className='mb-3'>
                          <img src="./offline_globe.svg" alt="" className="img-offline-globe-empty-result"></img>
                        </div>
                    }

                    <div>Impossibile caricare i Volantini.</div>
                    {
                        navigator.onLine
                        ?
                        <></>
                        :
                        <div>Verifica la connessione internet.</div>
                    }
                    </div>
                    :
                    <div className='nothing-find'>Nessun Volantino trovato</div>
                  }
                </div>
              }/>
        </div>
    )
}
        